import { Image, message } from "antd";
import axios from "axios";
import { create } from "zustand";
import { MAIN_URL } from "../../../Constants";

export const useCategorys = create((set, get) => ({
    categorys: [],
    ed: {},
    columns: [
        {
            title: 'Nomi',
            dataIndex: 'nameuz',
            key: 'nameuz'
        },
        {
            title: 'Nomi',
            dataIndex: 'nameru',
            key: 'nameru'
        },
        {
            title: "Ikonka",
            dataIndex: 'icon',
            key: 'icon',
            render: (_, record) => <Image src={MAIN_URL + '/' +record.icon} width={50} height={50} />
        }
    ],
    setEd: (v) => {
        set({ ed: v })
    },
    createCategory: (v) => {
        axios.post('/categorys', v).then(res => {
            get().getCategories()
            message.success("Muvaffaqiyatli qo'shildingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni qo'shishda muammo yuzaga keldi!!!")
        })
    },
    updateCategory: (v) => {
        axios.put('/categorys/' + v.id, v).then(res => {
            get().getCategories()
            message.success("Muvaffaqiyatli o'zgartirdingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni o'zgartirishda muammo yuzaga keldi!!!")
        })
    },
    deleteCategory: (id) => {
        axios.delete('/categorys/' + id).then(res => {
            get().getCategories()
            message.success("Muvaffaqiyatli o'chirdingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni o'chirishda muammo yuzaga keldi!!!")
        })
    },
    getCategories: () => {
        axios.get('/categorys').then(res => {
            set({ categorys: res.data })
        }).catch(error => {
            message.error("Ma'lumotlarni olishda muammo yuzaga keldi!!!")
        })
    }
}))